import { BaseControllerClass } from 'cerebral'
import { extractModuleProp } from 'cerebral/internal'
import Model from './Model'
// mobx-state-tree uses extra fields in modules and therefore needs to declare it's own `Module` constructor.
export { Module } from 'cerebral'

class MobxController extends BaseControllerClass {
  constructor(rootModule, options) {
    super(rootModule, options)
    this.provide = function() {
      return {
        store: this.model.state,
        signals: extractModuleProp(this.module, 'signals', (signals) => {
          return Object.keys(signals).reduce((runSignals, signalKey) => {
            if (signals[signalKey].run) {
              runSignals[signalKey] = signals[signalKey].run
            } else {
              runSignals[signalKey] = signals[signalKey]
            }

            return runSignals
          }, {})
        }),
      }
    }
  }
}

export function Controller(rootModule, options = {}) {
  options.Model = Model

  return new MobxController(rootModule, options)
}
